import { render } from "./RoversPage.vue?vue&type=template&id=28eb2d3a"
import script from "./RoversPage.vue?vue&type=script&lang=js"
export * from "./RoversPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__